(function () {
  'use strict';

  var STORAGE_KEY = 'unitGiftPopup';
  var SHOW_DELAY = 3500;

  function readState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      /* localStorage indisponible (navigation privée, etc.) : on ignore */
    }
  }

  var PRIZES = {
    remise20: {
      title: '-20% sur toute ta commande',
      text: "Incroyable, profite de -20% sur l'ensemble de ta commande.",
      code: 'MBU8Z5PE7',
      url: '/discount/MBU8Z5PE7?redirect=/collections/all',
      image: 'https://cdn.shopify.com/s/files/1/0886/3943/9192/files/7c2f8f08-ff21-484a-b6c5-36fe3dae5a2d.jpg?v=1767024421&width=200'
    },
    chambre: {
      title: 'Ta paire de chambres à air ultra-légères est offerte',
      text: "Ta paire de chambres à air ultra-légères t'est offerte.",
      code: 'CADEAU-CHAMBRE',
      url: '/discount/CADEAU-CHAMBRE?redirect=/products/chambre-a-air-ultra-legere',
      image: 'https://cdn.shopify.com/s/files/1/0886/3943/9192/files/p415x00_22d87976-37fd-4ab4-a166-69d5f4a7382a.png?v=1741026285&width=200'
    },
    remise: {
      title: '-10% sur toute ta commande',
      text: "Profite de -10% sur l'ensemble de ta commande.",
      code: 'CADEAU10',
      url: '/discount/CADEAU10?redirect=/collections/all',
      image: 'https://cdn.shopify.com/s/files/1/0886/3943/9192/files/7c2f8f08-ff21-484a-b6c5-36fe3dae5a2d.jpg?v=1767024421&width=200'
    },
    gp5000: {
      title: 'Incroyable, ta paire de pneus est offerte !',
      text: "Tu fais partie des 10% de chanceux : ta paire de pneus Continental GP5000 en 28mm t'est offerte.",
      code: 'CADEAU-GP5000',
      url: '/discount/CADEAU-GP5000?redirect=/collections/all',
      image: 'https://cdn.shopify.com/s/files/1/0886/3943/9192/files/gp5000-continental-28mm-nobg.png?v=1791875337'
    }
  };

  function pickPrize() {
    var r = Math.random() * 100;
    if (r < 2) return 'remise20';
    if (r < 12) return 'gp5000';
    if (r < 57) return 'chambre';
    return 'remise';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('UnitGiftPopup');
    if (!root) return;

    var closeBtn = root.querySelector('.u-gift__close');
    var form = root.querySelector('.u-gift__form');
    var emailInput = root.querySelector('#UnitGiftPopupEmail');
    var steps = {
      start: root.querySelector('[data-step="start"]'),
      prize: root.querySelector('[data-step="prize"]')
    };
    var boxesWrap = root.querySelector('.u-gift__boxes');
    var boxButtons = root.querySelectorAll('.u-gift-box');
    var prizeTitleEl = root.querySelector('.u-gift__prize-title');
    var prizeTextEl = root.querySelector('.u-gift__prize-text');
    var prizeMediaImg = root.querySelector('.u-gift__prize-media-img');
    var prizeMediaWrap = root.querySelector('.u-gift__prize-media');
    var codeEl = root.querySelector('.u-gift__code');
    var codeValueEl = root.querySelector('.u-gift__code-value');
    var codeCopyBtn = root.querySelector('.u-gift__code button');
    var codeCopyLabel = codeCopyBtn ? codeCopyBtn.querySelector('span') : null;
    var prizeCta = root.querySelector('.u-gift__prize-cta');

    if (!form || !emailInput || !boxesWrap || !prizeTitleEl || !prizeTextEl || !codeValueEl || !prizeCta || !prizeMediaImg) {
      return;
    }

    function showStep(name) {
      Object.keys(steps).forEach(function (k) {
        if (steps[k]) steps[k].classList.toggle('is-active', k === name);
      });
    }

    var prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var card = root.querySelector('.u-gift__card');

    /* Transition fluide entre étapes : la carte précédente glisse/s'efface,
       la hauteur de la fenêtre s'anime vers la nouvelle taille, puis le
       nouveau contenu (le code) apparaît en fondu. */
    function transitionToStep(name) {
      var toEl = steps[name];
      var fromEl = root.querySelector('.u-gift__step.is-active');
      if (!toEl || toEl === fromEl) return;

      if (prefersReducedMotion || !card) {
        showStep(name);
        return;
      }

      var startHeight = card.offsetHeight;
      card.style.height = startHeight + 'px';

      if (fromEl) fromEl.classList.add('is-leaving');

      setTimeout(function () {
        if (fromEl) fromEl.classList.remove('is-active', 'is-leaving');
        toEl.classList.add('is-active', 'is-entering');

        card.style.height = 'auto';
        var endHeight = card.offsetHeight;
        card.style.height = startHeight + 'px';

        requestAnimationFrame(function () {
          card.style.height = endHeight + 'px';
          requestAnimationFrame(function () {
            toEl.classList.add('is-entered');
          });
        });

        setTimeout(function () {
          card.style.height = '';
          toEl.classList.remove('is-entering', 'is-entered');
        }, 460);
      }, 300);
    }

    function openPopup() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function closePopup(markDismissed) {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (markDismissed) {
        var s = readState();
        s.dismissed = true;
        writeState(s);
        showChip();
      }
    }

    function unlockBoxes() {
      root.classList.add('is-unlocked');
      boxButtons.forEach(function (btn) { btn.disabled = false; });
    }

    /* ---- chip persistant « récompense » (reste affiché après fermeture du pop-up) ---- */
    function reopenFromChip() {
      var s = readState();
      hideChip();
      if (s.claimed && s.prize && PRIZES[s.prize]) {
        var prize = PRIZES[s.prize];
        prizeTitleEl.textContent = prize.title;
        prizeTextEl.textContent = prize.text;
        codeValueEl.textContent = prize.code;
        prizeCta.setAttribute('href', prize.url);
        prizeMediaImg.setAttribute('src', prize.image);
        prizeMediaImg.setAttribute('alt', prize.title);
        if (prizeMediaWrap) {
          prizeMediaWrap.classList.toggle('u-gift__prize-media--plain', s.prize === 'gp5000');
        }
        showStep('prize');
      } else {
        showStep('start');
      }
      openPopup();
    }

    function buildChip() {
      var chip = document.getElementById('UnitGiftChip');
      if (chip) return chip;

      chip = document.createElement('div');
      chip.id = 'UnitGiftChip';
      chip.className = 'u-gift-chip';
      chip.setAttribute('role', 'button');
      chip.setAttribute('tabindex', '0');
      chip.setAttribute('aria-label', 'Voir ma récompense');
      chip.innerHTML =
        '<span class="u-gift-chip__icon" aria-hidden="true"><img src="https://cdn.shopify.com/s/files/1/0886/3943/9192/files/ACTUAL_DESIGN_-_This_is_what_we_publish.png?v=1783875018&width=160" alt="" loading="lazy" width="100" height="100"></span>' +
        '<span class="u-gift-chip__text u-gift-chip__text--full"></span>' +
        '<span class="u-gift-chip__text u-gift-chip__text--short">Ton code</span>' +
        '<button type="button" class="u-gift-chip__close" aria-label="Fermer">' +
          '<svg viewBox="0 0 16 16" width="10" height="10" aria-hidden="true"><path d="M1 1L15 15M15 1L1 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>' +
        '</button>';

      document.body.appendChild(chip);

      chip.addEventListener('click', function (e) {
        if (e.target.closest('.u-gift-chip__close')) return;
        reopenFromChip();
      });
      chip.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          reopenFromChip();
        }
      });

      var closeChipBtn = chip.querySelector('.u-gift-chip__close');
      closeChipBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var s = readState();
        s.chipClosed = true;
        writeState(s);
        hideChip();
      });

      return chip;
    }

    function renderChipContent() {
      var chip = document.getElementById('UnitGiftChip');
      if (!chip) return;
      var s = readState();
      var textEl = chip.querySelector('.u-gift-chip__text--full');
      if (s.claimed && s.prize && PRIZES[s.prize]) {
        textEl.textContent = 'Ton code : ' + PRIZES[s.prize].code;
      } else {
        textEl.textContent = 'Ta récompense t\'attend';
      }
    }

    function showChip() {
      var s = readState();
      if (s.chipClosed) return;
      buildChip();
      renderChipContent();
      var chip = document.getElementById('UnitGiftChip');
      if (chip) chip.classList.add('is-visible');
    }

    function hideChip() {
      var chip = document.getElementById('UnitGiftChip');
      if (chip) chip.classList.remove('is-visible');
    }

    /* Fermeture uniquement via la croix : c'est au client de décider quand quitter,
       pas un clic accidentel sur le fond ou la touche Echap. */
    if (closeBtn) closeBtn.addEventListener('click', function () { closePopup(true); });

    /* Neutralise un appel natif form.submit() déclenché par un script tiers de la
       boutique (protection anti-spam hCaptcha de Shopify sur les formulaires
       client). Un tel appel direct ignore nos écouteurs d'événement "submit" et
       provoquait un rechargement complet de la page juste après notre envoi AJAX.
       On ne touche qu'à cette instance précise du formulaire : les autres
       formulaires du site ne sont pas affectés. */
    form.submit = function () {};

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      root.classList.remove('has-error');
      var email = emailInput.value.trim();
      if (!email) return;
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      var fd = new FormData(form);
      fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function () {
          var s = readState();
          s.emailSubmitted = true;
          writeState(s);
          unlockBoxes();
        })
        .catch(function () {
          root.classList.add('has-error');
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });

    boxButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || boxesWrap.classList.contains('is-deciding')) return;
        boxesWrap.classList.add('is-deciding');

        var prizeKey = pickPrize();
        var prize = PRIZES[prizeKey];

        var s = readState();
        s.claimed = true;
        s.prize = prizeKey;
        s.code = prize.code;
        writeState(s);
        try { if (window.klaviyo && typeof window.klaviyo.identify === 'function' && emailInput && emailInput.value) { window.klaviyo.identify({ email: emailInput.value.trim() }); } if (window.klaviyo && typeof window.klaviyo.track === 'function') { window.klaviyo.track('Gift Popup Won', { prize_key: prizeKey, prize_title: prize.title, discount_code: prize.code, discount_url: prize.url }); } } catch (klError) {}

        var revealPrize = function () {
          prizeTitleEl.textContent = prize.title;
          prizeTextEl.textContent = prize.text;
          codeValueEl.textContent = prize.code;
          prizeCta.setAttribute('href', prize.url);
          prizeMediaImg.setAttribute('src', prize.image);
          prizeMediaImg.setAttribute('alt', prize.title);
          if (prizeMediaWrap) {
            prizeMediaWrap.classList.toggle('u-gift__prize-media--plain', prizeKey === 'gp5000');
          }
          transitionToStep('prize');
        };

        /* Petit suspense avant la révélation : le coffre choisi vibre et grossit
           (is-charging), puis bascule dans l'animation d'ouverture existante
           (is-picked) avant d'afficher le prix. */
        if (prefersReducedMotion) {
          btn.classList.add('is-picked');
          setTimeout(revealPrize, 1200);
          return;
        }

        btn.classList.add('is-charging');
        setTimeout(function () {
          btn.classList.remove('is-charging');
          btn.classList.add('is-picked');
        }, 650);
        setTimeout(revealPrize, 1850);
      });
    });

    if (codeCopyBtn) {
      codeCopyBtn.addEventListener('click', function () {
        var text = codeValueEl.textContent.trim();
        if (!navigator.clipboard || !navigator.clipboard.writeText) return;
        navigator.clipboard.writeText(text).then(function () {
          codeEl.classList.add('is-copied');
          if (codeCopyLabel) {
            var original = codeCopyLabel.textContent;
            codeCopyLabel.textContent = 'Copié !';
            setTimeout(function () {
              codeCopyLabel.textContent = original;
              codeEl.classList.remove('is-copied');
            }, 1800);
          }
        });
      });
    }

    var initialState = readState();
    if (initialState.dismissed) {
      showChip();
    } else {
      setTimeout(function () {
        var s = readState();
        if (!s.claimed && !s.dismissed) openPopup();
      }, SHOW_DELAY);
    }
  });
})();
